export default "__VITE_ASSET__6c67052a__"